import API from "@constants/API";

const BASE_URL = "https://api.prod.dailyapp.id/api-v1-brand-payment/lumiere?";

export const getPaymentBrandAPI = async (startDate: string, endDate: string) => {
  const res = await API.HTTP.get(`${BASE_URL}startdate=${startDate}&enddate=${endDate}`);
  return res.data;
};
